import { getUserPath, HttpMethod, submitApiRequest } from "@/services/aplosApi";
import { GetRulesArgs } from "../models/GetRulesArgs";
import { Rule } from "../models/Rule";
import { IResourceMetadataEntry } from "@/components/FileManager/models/IResourceMetadataEntry";
import { QueueExecutionResponse } from "@/shared/Executions/models/QueueExecutionResponse";
import { QueueDataCleaningArgs } from "@/shared/Executions/models/QueueDataCleaningArgs";
import { QueueExecutionArgs } from "@/shared/Executions/models/QueueExecutionArgs";
import { AxiosResponse } from "axios";
import { InjectableService } from "@/shared/services/InjectableService";
import { IExecutionApiService } from "@/shared/Executions/services/ExecutionApiService";


export interface IDataCleaningApiService {
  processRules: (userId: string, tenantId: string, args: QueueDataCleaningArgs) => Promise<AxiosResponse<QueueExecutionResponse>>;
  getRules: (args: GetRulesArgs) => Promise<Array<Rule>>
}

export class DataCleaningApiService extends InjectableService implements IDataCleaningApiService {

  static readonly injectableKey = 'IDataCleaningApiService';

  get injectableKey() {
    return (this.constructor as typeof DataCleaningApiService).injectableKey;
  }

  constructor(private readonly _executionApiService: IExecutionApiService) {
    super()
  }

  public async processRules(userId: string, tenantId: string, args: QueueDataCleaningArgs): Promise<AxiosResponse<QueueExecutionResponse>> {

    const qeueueExecutionArgs = new QueueExecutionArgs({ tenantId, userId, dataCleaningArgs: args });

    return await this._executionApiService.queueExecution(qeueueExecutionArgs);

  }

  // TODO: we might add an additional get config via execution Id method here too
  public async getRules(args: GetRulesArgs): Promise<Array<Rule> & any> {

    const response = await submitApiRequest(
      HttpMethod.GET,
      `${getUserPath(args.tenantId, args.userId)}/files/${args.fileId}/meta?key=${args.key}&preserveFields=${args.preserveFields}`
    );

    const resourceMetadataEntry = response.data as IResourceMetadataEntry;
    const dataProcessingPayload = resourceMetadataEntry.metadata as any; //TODO Is this an existing executeApiService related type?

    return dataProcessingPayload?.rules;

  }

}
